import * as React from 'react';
import {Stack, Button, Avatar, IconButton} from '@mui/material';
import {Logout} from '@mui/icons-material';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faLinkedin, faInstagram, faFacebookF, faTiktok, faYoutube} from '@fortawesome/free-brands-svg-icons';
import AuthContext from '../../context/AuthContext';
import {useContext} from 'react';
import {useMediaQuery} from '@mui/material';

/**
 * Array of objects used to fill the data in SocialMediaBottomNavigation component
 * label:string - for accessibility
 * link:string - URL to that social media site
 * iconBGColor:string - color
 * icon:FontAwesomeIcon - Must be a circle with a logo in the center for consistency
 */
const socialMediaPlatformsData = [
  {
    label: 'facebook',
    link: 'https://www.facebook.com/aimdofficial',
    iconBGColor: '#006DEB',
    icon: faFacebookF,
  },
  {
    label: 'instagram',
    link: 'https://www.instagram.com/ai_md_official/',
    iconBGColor: '#FA0A6A',
    icon: faInstagram,
  },
  {
    label: 'titok',
    link: 'https://www.tiktok.com/@ai_md_official',
    iconBGColor: '#000000',
    icon: faTiktok,
  },
  {
    label: 'linkedin',
    link: 'https://www.linkedin.com/company/ai-md-official',
    iconBGColor: '#005CB6',
    icon: faLinkedin,
  },
  {
    label: 'youtube',
    link: 'https://www.youtube.com/@ai_md_official',
    iconBGColor: '#FF0000',
    icon: faYoutube,
  },
];

/**
 * SocialMediaBottomNavigation
 * Group of buttons with information about social media of aimd. It also includes a logout button
 *
 * @returns {React.Component} Rendered Component
 */
export default function SocialMediaBottomNavigation() {
  const {logOutUser} = useContext(AuthContext);
  const isSmallScreen = useMediaQuery('(max-width:300px)');
  const is600pxDown = useMediaQuery('(max-width:600px)');

  return (
    <Stack direction="row" alignItems="center" justifyContent="center" spacing={isSmallScreen ? 0 : 0.5} sx={{pt: 1}}>
      <Button
        variant="outlined"
        aria-label="logout"
        startIcon={<Logout />}
        component="label"
        sx={{
          borderColor: '#3DA9F8',
          color: '#3DA9F8',
          borderRadius: 5,
          fontWeight: 500,
          fontSize: isSmallScreen ? 12 : 14,
          mr: isSmallScreen ? 0.3 : 0,
          borderWidth: isSmallScreen ? 2 : 3,
          ':hover': {
            borderWidth: isSmallScreen ? 2 : 3,
            backgroundColor: '#3DA9F8',
            color: '#FFFFFF',
          },
          '& .MuiButton-startIcon': {
            margin: 0,
          },
        }}
        onClick={logOutUser}
      >
        {is600pxDown ? '' : 'Logout'}
      </Button>
      {socialMediaPlatformsData.map((platform, idx) => (
        <IconButton
          key={idx}
          color="primary"
          aria-label={platform.label}
          component="label"
          onClick={() => window.open(platform.link, '_blank')}
        >
          <Avatar
            sx={{
              bgcolor: platform.iconBGColor,
              height: isSmallScreen ? 20 : 28,
              width: isSmallScreen ? 20 : 28,
            }}
          >
            <FontAwesomeIcon icon={platform.icon} size={isSmallScreen ? 'xs' : 'sm'} />
          </Avatar>
        </IconButton>
      ))}
    </Stack>
  );
}
